// src/pages/Sustainability.js
import React, { useEffect, useRef } from 'react';
import { useContent } from '../context/ContentContext';
import EcoMaterials from '../components/sustainability/EcoMaterials';
import EthicalProduction from '../components/sustainability/EthicalProduction';
import ImpactStats from '../components/sustainability/ImpactStats';
import { Link } from 'react-router-dom';
import Button from '../components/common/Button';
import { fadeIn } from '../utils/gsapAnimations';

function Sustainability() {
  const pageRef = useRef(null);
  const { content, loading, error } = useContent();

  useEffect(() => {
    fadeIn(pageRef.current, 0.3);
  }, []);

  if (loading) return <div className="text-center py-12 text-primary">Loading...</div>;
  if (error) return <div className="text-center py-12 text-red-500">{error}</div>;

  const sustainabilityContent = content.sustainability || {};

  return (
    <div ref={pageRef} className="bg-cream">
      <div className="max-w-7xl mx-auto py-12 px-4">
        <h1 className="text-3xl font-lora font-semibold text-primary mb-6">
          {sustainabilityContent.title || 'Our Sustainability Commitment'}
        </h1>
        <EcoMaterials content={sustainabilityContent.ecoMaterials} />
        <EthicalProduction content={sustainabilityContent.ethicalProduction} />
        <ImpactStats content={sustainabilityContent.impactStats} />
        <div className="py-12 px-4 text-center">
          <h2 className="text-2xl font-lora font-semibold text-primary mb-4">
            {sustainabilityContent.carbonNeutral?.title || 'Carbon Neutral Commitment'}
          </h2>
          <p className="text-poppins mb-4 max-w-2xl mx-auto">
            {sustainabilityContent.carbonNeutral?.description ||
              'We’re proud to be carbon neutral by offsetting 100% of our emissions through reforestation and renewable energy projects.'}
          </p>
          <Link to="/shop">
            <Button
              className="bg-primary text-cream px-6 py-3 text-lg font-montserrat rounded-full hover:bg-primary/90"
            >
              {sustainabilityContent.carbonNeutral?.buttonText || 'Shop Carbon Neutral'}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Sustainability;